// A fresh scoped query per page preserves the caller's RLS/auth context.
// Count-based termination also handles API caps below the requested page size.
export const readAllRows = async (createQuery, pageSize = 500) => {
  const rows = [];
  const seen = new Set();
  let total = null;
  while (true) {
    const { data, error, count } = await createQuery().range(rows.length, rows.length + pageSize - 1);
    if (error) throw error;
    if (typeof count !== 'number') throw new Error('Unable to verify the full activity history. Please retry.');
    if (total === null) total = count;
    if (count !== total) throw new Error('Activity changed while loading. Please refresh and try again.');
    const page = data || [];
    if (!page.length && rows.length < total) throw new Error('The full activity history could not be loaded. Please retry.');
    for (const row of page) {
      if (seen.has(row.id)) throw new Error('Activity changed while loading. Please refresh and try again.');
      seen.add(row.id);
      rows.push(row);
    }
    if (rows.length >= total) return rows;
  }
};
